const paymentStatusStates = [
  { id: 0, key: "none", icon: { icon: "", color: "" } },
  { id: 1, key: "success", icon: { icon: "$checkmark", color: "success" } },
  { id: 2, key: "aborted", icon: { icon: "$aborted", color: "primary" } },
  { id: 3, key: "declined", icon: { icon: "$declined", color: "error" } },
  { id: 4, key: "tokenized", icon: { icon: "$token", color: "success" } },
  { id: 5, key: "linkCreated", icon: { icon: "$link", color: "success" } },
  { id: 6, key: "notified", icon: { icon: "$notify", color: "success" } },
  { id: 7, key: "authorized", icon: { icon: "$authorize", color: "success" } },
  { id: 8, key: "captured", icon: { icon: "$capture", color: "success" } },
  { id: 9, key: "expired", icon: { icon: "$expire", color: "error" } },
  {
    id: 10,
    key: "initialized",
    icon: { icon: "$initialized", color: "success" },
  },
  { id: 11, key: "reminded", icon: { icon: "$email_plus", color: "success" } },
  { id: 12, key: "inProgress", icon: { icon: "$progress", color: "success" } },
  { id: 13, key: "linkClicked", icon: { icon: "$clicked", color: "success" } },
  { id: 14, key: "refunded", icon: { icon: "$refunds", color: "primary" } },
  { id: 15, key: "planned", icon: { icon: "$planned", color: "success" } },
  {
    id: 16,
    key: "sessionCreated",
    icon: { icon: "$session_created", color: "info" },
  },
  { id: 17, key: "partialRefund", icon: { icon: "$refunds", color: "info" } },
  {
    id: 18,
    key: "chargeBackRequest",
    icon: { icon: "$refunds", color: "error" },
  },
  { id: 19, key: "chargedBack", icon: { icon: "$refunds", color: "error" } },
];

const paymentSources = [
  { id: 54, icon: "$automode" },
  { id: 57, icon: "$book_marker" },
  { id: 58, icon: "$desktop" },
  { id: 59, icon: "$pasta" },
];

const paymentTypes = [
  { id: 0, key: "none" },
  { id: 1, key: "deposit" },
  { id: 2, key: "refund" },
  { id: 3, key: "charge" },
  { id: 4, key: "authorize" },
  { id: 5, key: "paylink" },
  { id: 6, key: "capture" },
  { id: 7, key: "checkout" },
  { id: 8, key: "cancel" },
  { id: 9, key: "preAuthorize" },
  { id: 10, key: "chargeback" },
  { id: 11, key: "pos" },
];

const paymentLinkLanguages = [
  { id: "en-US", key: "english" },
  { id: "de-DE", key: "german" },
  { id: "nl-NL", key: "dutch" },
  { id: "fr-FR", key: "french" },
  { id: "it-IT", key: "italian" },
  { id: "da-DK", key: "danish" },
  { id: "nn-NO", key: "norwegian" },
  { id: "sv-SE", key: "swedish" },
  { id: "fi-FI", key: "finnish" },
];

const paymentMethods = [
  { id: "AX", name: "American Express", logo: "americanExpress" },
  { id: "BCMC", name: "Bancontact", logo: "bancontact" },
  { id: "DN", name: "Diners", logo: "dinersClub" },
  { id: "DISCOVER", name: "Discover", logo: "discover" },
  { id: "ID", name: "iDEAL", logo: "ideal_logo" },
  { id: "KLARNA", name: "Klarna", logo: "klarna" },
  { id: "MS", name: "Maestro", logo: "maestro_logo" },
  { id: "MC", name: "Mastercard", logo: "mastercard" },
  { id: "MOBILEPAY", name: "MobilePay", logo: "mobilePay" },
  {
    id: "BCMC_MOBILE",
    name: "Payconiq by Bancontact",
    logo: "payconicByBancontact",
  },
  { id: "PAYPAL", name: "PayPal", logo: "payPal" },
  { id: "VIPPS", name: "Vipps", logo: "vipps" },
  { id: "VI", name: "VISA", logo: "visa_logo" },
];

const emailStatusStates = [
  { id: 0, key: "none", icon: { icon: "", color: "" } },
  { id: 1, key: "notDelivered", icon: { icon: "$email", color: "error" } },
  { id: 2, key: "dropped", icon: { icon: "$email_remove", color: "error" } },
  {
    id: 3,
    key: "delivered",
    icon: { icon: "$email_check", color: "success" },
  },
  {
    id: 4,
    key: "deferred",
    icon: { icon: "$email_search", color: "primary" },
  },
  { id: 5, key: "bounce", icon: { icon: "$email_receive", color: "error" } },
  { id: 6, key: "open", icon: { icon: "$email_open", color: "success" } },
  { id: 7, key: "click", icon: { icon: "$email_plus", color: "success" } },
  { id: 8, key: "spam", icon: { icon: "$email_lock", color: "error" } },
  { id: 9, key: "other", icon: { icon: "$email_alert", color: "primary" } },
];

const accountStatusStates = [
  { id: 0, key: "offline" },
  { id: 1, key: "online" },
  { id: 2, key: "unverified" },
  { id: 3, key: "blocked" },
];

const accessTypes = [
  { id: 1, key: "hotelUser" },
  { id: 2, key: "hotelAdmin" },
  { id: 3, key: "cloudUser" },
  { id: 4, key: "cloudAdmin" },
  { id: 5, key: "chainUser" },
  { id: 6, key: "chainAdmin" },
  { id: 7, key: "apiUser" },
  { id: 8, key: "apiAdmin" },
  { id: 10, key: "globalAdmin" },
  { id: 11, key: "paymentUser" },
  { id: 12, key: "paymentAdmin" },
  { id: 13, key: "ibeUser" },
  { id: 14, key: "ibeAdmin" },
];

const resStatusTypes = [
  { id: 0, key: "none" },
  { id: 1, key: "new", color: "success" },
  { id: 2, key: "modify", color: "#FFC133" },
  { id: 3, key: "cancel", color: "error" },
  { id: 4, key: "noShow", color: "error" },
  { id: 5, key: "optional", color: "#ffff00" },
  { id: 6, key: "requested", color: "#FFC133" },
  { id: 7, key: "waitListed", color: "#FFC133" },
  { id: 8, key: "reserved", color: "success" },
  { id: 9, key: "inHouse", color: "#0000ff" },
  { id: 10, key: "checkedIn", color: "#0066E1" },
  { id: 11, key: "checkedOut", color: "#0066E1" },
  { id: 12, key: "definite", color: "success" },
  { id: 13, key: "tentative", color: "#ffa500" },
  { id: 14, key: "charge", color: "#bb00ff" },
  { id: 15, key: "departed", color: "#800080" },
];

const resProfileTypes = [
  { id: 0, key: "none" },
  { id: 1, key: "guest", actionKey: "sendPaylink" },
  { id: 2, key: "gds" },
  { id: 3, key: "corporation", actionKey: "requestAuthorisation" },
  { id: 4, key: "travelAgent", actionKey: "requestAuthorisation" },
  { id: 5, key: "wholesaler" },
  { id: 6, key: "group" },
  { id: 8, key: "cro" },
  { id: 18, key: "billingContact", actionKey: "sendPaylink" },
];

const paymentCardTypes = [
  { id: 0, key: "paylink", icon: { icon: "$paylink", color: "black" } },
  { id: 1, key: "creditCard", icon: { icon: "$creditcard", color: "black" } },
  { id: 2, key: "virtualCard", icon: { icon: "$virtualcard", color: "black" } },
  { id: 3, key: "checkout", icon: { icon: "$checkout", color: "black" } },
  { id: 4, key: "terminal", icon: { icon: "$terminal", color: "black" } },
];

const createPaylinkOptions = [
  { id: 18, key: "guest" },
  { id: 3, key: "corporation" },
  { id: 4, key: "travelAgent" },
];

const attachmentTypes = [
  { id: 0, key: "none" },
  { id: 1, key: "confirmation" },
  { id: 2, key: "invoice" },
  { id: 3, key: "letter" },
];

const creditCardTypes = [
  { code: "AX", text: "American Express" },
  { code: "MC", text: "Mastercard" },
  { code: "VI", text: "VISA" },
];

const metricDateTypes = [
  { id: 1, key: "today" },
  { id: 2, key: "thisWeek" },
  { id: 3, key: "thisMonth" },
  { id: 4, key: "ytd" },
];

const amountMetrics = [
  {
    id: 1,
    titleKey: "captured",
    icon: "$captured_transactions",
    data: null,
    filterParams: {
      paymentStatus: 8,
    },
  },
  {
    id: 2,
    titleKey: "authorized",
    icon: "$authorized_transactions",
    data: null,
    filterParams: {
      paymentStatus: 7,
    },
  },
  {
    id: 3,
    titleKey: "declined",
    icon: "$declined_transactions",
    data: null,
    filterParams: {
      paymentStatus: 3,
    },
  },
  {
    id: 4,
    titleKey: "refunds",
    icon: "$refunds",
    data: null,
    filterParams: {
      paymentStatus: 14,
    },
  },
];

const dateTypes = [
  { id: 0, key: "created" },
  { id: 1, key: "lastActivity" },
  { id: 2, key: "arrival" },
  { id: 6, key: "paymentsOnly" },
];

const overviewModuses = [
  { id: "overview", level: 0 },
  { id: "advancedSearch", level: 0 },
  { id: "zeroAmounts", level: 3 },
  { id: "openCharges", level: 4 },
  { id: "openCaptures", level: 5 },
];

const mailTemplateTypes = [
  { id: 1, key: "paymentLink" },
  { id: 2, key: "reminder" },
  { id: 3, key: "expiration" },
  { id: 4, key: "paymentPage" },
  { id: 5, key: "thankYou" },
  { id: 6, key: "deposit" },
  { id: 7, key: "authorize" },
  { id: 8, key: "failover" },
  { id: 9, key: "confirmationPdf" },
  { id: 10, key: "confirmationEmail" },
  { id: 12, key: "cancellationPdf" },
  { id: 13, key: "cancellationEmail" },
];

const mailTemplateLocales = [
  { id: "en-US", key: "english" },
  { id: "de-DE", key: "german" },
  { id: "nl-NL", key: "dutch" },
  { id: "fr-FR", key: "french" },
  { id: "it-IT", key: "italian" },
  { id: "da-DK", key: "danish" },
  { id: "nn-NO", key: "norwegian" },
  { id: "sv-SE", key: "swedish" },
  { id: "fi-FI", key: "finnish" },
];

function defaultPaymentForReservationPaymentDetails() {
  return {
    hotelCode: "",
    language: "",
    reservationID: "",
    resStatus: 1,
    startDate: "",
    resTotal: null,
    profiles: [],
    description: "",
    duration: null,
    inventoryBlockCode: "",
    card: {
      cardCode: "",
      cardHolderName: "",
      cardNumber: "",
      seriesCode: "",
      cardToken: "",
      expireDate: "",
      vccEffectiveDate: "",
      vccExpirationDate: "",
      vccBalance: 0,
      expiryMonth: "",
      expiryYear: "",
    },
  };
}

function createProfile(profileType) {
  return {
    profileType: profileType,
    address: "",
    name: "",
    postalCode: "",
    cityName: "",
    countryCode: "",
    phoneNumber: "",
    email: "",
  };
}

export {
  paymentStatusStates,
  paymentTypes,
  paymentSources,
  paymentLinkLanguages,
  paymentMethods,
  createPaylinkOptions,
  emailStatusStates,
  accountStatusStates,
  accessTypes,
  resStatusTypes,
  resProfileTypes,
  creditCardTypes,
  paymentCardTypes,
  metricDateTypes,
  amountMetrics,
  dateTypes,
  overviewModuses,
  mailTemplateTypes,
  mailTemplateLocales,
  attachmentTypes,
  defaultPaymentForReservationPaymentDetails,
  createProfile,
};
